/**
 * Information about the platform Bridge is running on. `data` is platform specific.
 */
export type Platform = {
	kind: PlatformKind
	username?: string
	data?: unknown
}

export enum PlatformKind {
	ADVANCEDMD = 'advancedmd',
	ATHENA = 'Athena',
	AZALEA = 'azalea',
	AZARA = 'azara',
	CAREECO = 'careeco',
	CLINICIENT = 'clinicient',
	CROSSTX = 'crosstx',
	ECW = 'eCW',
	ELATION = 'Elation',
	EMPOWER = 'empower',
	GGASTRO = 'ggastro',
	HENO = 'heno',
	IKNOWMED = 'iknowmed',
	NETHEALTH = 'nethealth',
	NETSMART = 'netsmart',
	NEXTGEN = 'nextgen',
	OFFICEALLY = 'Office Ally',
	ONCOEMR = 'oncoemr',
	PRACTICEFUSION = 'practicefusion',
	PROMPT = 'prompt',
	PTEVERYWHERE = 'pteverywhere',
	PTPRACTICEPRO = 'ptpracticepro',
	RAINTREE = 'raintree',
	SIRRUS = 'sirrus',
	STRATAEMR = 'strataemr',
	STRATUS = 'stratus',
	THRIVE = 'thrive',
	TEBRA = 'tebra',
	TURBOPT = 'turbopt',
	WEBPT = 'webpt',
	OTHER = 'Other'
}
